<footer class="bd-footer text-muted">
	<div class="container">
		<p> Coded with <i class="fa fa-heart heart"></i> by <a href="https://github.com/michaeldoye" target="_blank">Michael Doye</a>.</p>
		<p> Code licensed under <a href="https://raw.githubusercontent.com/michaeldoye/mat-progress-buttons/master/LICENSE" target="_blank">MIT license conditions.</a></p>
	</div>
</footer>